import { ACCOUNTANT } from "../types";

export const setSelectedAccountant = (selectAccountant: any) => {
	return {
		type: ACCOUNTANT.ACCOUNTANT_SET_SELECTED,
		payload: { ...selectAccountant },
	};
};

export const clearSelectedAccountant = () => {
	return {
		type: ACCOUNTANT.ACCOUNTANT_CLEAR_SELECTED,
	};
};
export const setSelectedAccountantName = (selectAccountant: any) => {
	return {
	  type: ACCOUNTANT.ACCOUNTANT_NAME_SET_SELECTED,
	  payload: {...selectAccountant}
	}
  }
  
  export const clearSelectedAccountantName = () => {
	return {
	  type: ACCOUNTANT.ACCOUNTANT_NAME_CLEAR_SELECTED
	}
  }